import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "@/views/Home.vue";
import Pricing from "@/views/Pricing/index.vue";
import Admin from "@/views/Admin/index.vue";
import Auth from "@/views/Auth.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: Pricing
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin
  },
  {
    path: "/auth/:target?",
    name: "Auth",
    component: Auth
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
